import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { ClickAwayListener } from '@mui/material';

import { getResetButtons, getResetButtonsMenu } from '../../../common/constants/resetButtons';
import Button from '../../../common/components/Button/Button';
import Menu from '../../../common/components/Menu/Menu';

function ResetButtons({ toggleSnackbar, currentChargerData, isFetching, config, openResetDialog, user }) {
  const [openResetPopover, setOpenResetPopover] = useState(false);
  const anchorEl = useRef(null);

  const handleCloseSnackBar = () => {
    toggleSnackbar(false);
  };

  useEffect(() => {
    handleCloseSnackBar();
  }, []);

  const handleClick = (event) => {
    event.preventDefault();
    anchorEl.current = event.currentTarget;

    setOpenResetPopover(true);
  };

  const handleRequestClose = () => {
    setOpenResetPopover(false);
  };

  const isOnline = get(currentChargerData, 'i2p2_state.c_online');
  const resetButtons = getResetButtons(currentChargerData, config, user.currentPermissions);
  let innerHtml;

  if (resetButtons.length > 1) {
    const menuItems = getResetButtonsMenu(resetButtons, handleRequestClose.bind(this), openResetDialog);

    innerHtml = (
      <ClickAwayListener onClickAway={handleRequestClose}>
        <span style={{ display: 'flex' }}>
          <Button onClick={handleClick} className="table-button-with-span" disabled={!isOnline || isFetching} variant="contained">
            <ExpandMoreIcon />
            Reset
          </Button>
          <Menu open={openResetPopover} anchorEl={anchorEl.current} placement="bottom-start">
            {menuItems}
          </Menu>
        </span>
      </ClickAwayListener>
    );
  } else if (currentChargerData) {
    innerHtml = resetButtons.map((button) => (
      <Button
        key={button.label}
        className="table-button-with-span"
        disabled={!isOnline || isFetching}
        variant="contained"
        onClick={() => openResetDialog(button.command)}
      >
        {button.label}
      </Button>
    ));
  }

  return <span className="table-button-with-span-wrapper">{innerHtml}</span>;
}

ResetButtons.propTypes = {
  config: PropTypes.object.isRequired,
  currentChargerData: PropTypes.object,
  isFetching: PropTypes.bool.isRequired,
  openResetDialog: PropTypes.func.isRequired,
  user: PropTypes.object,
  toggleSnackbar: PropTypes.func,
};

export default ResetButtons;
